var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-input field", style: { maxWidth: _vm.maxWidth } },
    [
      _c("input", {
        style: { maxWidth: _vm.maxWidth },
        attrs: {
          disabled: _vm.disabled,
          name: _vm.name,
          placeholder: " ",
          readonly: _vm.readonly,
          type: _vm.type
        },
        domProps: { value: _vm.value },
        on: { input: _vm.onInputChange }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37e50b8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e50b8d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/text-input.vue
// module id = 1362
// module chunks = 0